<template>
  <Layout>
    <div>
      <h3>PROFILE</h3>
      <div v-if="user">
        <h2>{{ user.name }}</h2>
        <img v-if="user.photoUrl" class="w-10" :src="user.photoUrl" alt="">
        <p>{{ user.email }}</p>
      </div>
      <DrButton @click="onLogout">Logout</DrButton>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/router/layouts/Full.vue'

export default {
  components: {
    Layout,
  },
  data () {
    return {}
  },
  computed: {
    user () {
      return this.$store.getters['user/user']
    },
  },
  created () {
    this.$store.dispatch('shared/clearError')
  },
  methods: {
    onLogout () {
      this.$store.dispatch('user/logout')
      this.$router.push({
        name: 'user-login',
        params: { partnerId: this.$store.getters['user/loginFlow'].partner },
        query: { u: 'signin' },
      })
    },
  },
}
</script>
